var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "testimonialCreateModal",
        "data-bs-backdrop": "static",
        "data-bs-keyboard": "false",
        tabindex: "-1",
        "aria-labelledby": "testimonialCreateModalLabel",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog modal-lg" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c(
              "h1",
              {
                staticClass: "modal-title fs-5",
                attrs: { id: "testimonialCreateModalLabel" },
              },
              [
                _vm._v(
                  "\n                    Utaztál már velünk? Írd meg a véleményed te is\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c("button", {
              staticClass: "btn-close",
              attrs: {
                type: "button",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
                disabled: _vm.saving,
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body text-start" }, [
            _c(
              "form",
              {
                attrs: {
                  action: _vm.url,
                  method: "POST",
                  id: "testimonialCreateModalForm",
                },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.submit.apply(null, arguments)
                  },
                },
              },
              [
                _c("div", { staticClass: "mb-3" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "testimonialCreateModalFormName" },
                    },
                    [
                      _vm._v(
                        "\n                            Név\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.name,
                        expression: "form.name",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      name: "name",
                      id: "testimonialCreateModalFormName",
                      maxlength: "255",
                      required: "",
                      disabled: _vm.saving,
                    },
                    domProps: { value: _vm.form.name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form, "name", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-3" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "testimonialCreateModalContent" },
                    },
                    [
                      _vm._v(
                        "\n                            Véleményem, tapasztalatom\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.content,
                        expression: "form.content",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      name: "content",
                      id: "testimonialCreateModalContent",
                      maxlength: "2000",
                      required: "",
                      disabled: _vm.saving,
                    },
                    domProps: { value: _vm.form.content },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form, "content", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-3" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "testimonialCreateModalFormPhoto" },
                    },
                    [
                      _vm._v(
                        "\n                            Feltöltök egy fotót magamról\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control",
                    attrs: {
                      type: "file",
                      name: "name",
                      id: "testimonialCreateModalFormPhoto",
                      accept: "image/bmp,image/gif,image/jpeg,image/png",
                      required: "",
                      disabled: _vm.saving,
                    },
                    on: { change: _vm.setPhoto },
                  }),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: {
                  type: "button",
                  "data-bs-dismiss": "modal",
                  disabled: _vm.saving,
                },
              },
              [_vm._v("\n                    Mégse\n                ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "submit", form: "testimonialCreateModalForm" },
              },
              [_vm._v("\n                    Elküld\n                ")]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }